<template lang="pug">
  v-select(:disabled="disabled" 
    v-model.trim="data" 
    :readonly="readonly" 
    :items="listData"
    :rules="rules"
    :label="label"
    :required="required" 
    :item-text="text" 
    item-value="jenisSetoran" 
    @change="onSelect")
</template>
<script>
    export default {
        name: "FSelectJenisSetoran",
        props: ["value", "listData", "disabled", "readonly", "rules", "required", "label"],
        data() {
            return {
                data : null
            };
        },
        mounted() {
            this.data = this.value;
        },
        watch: {
            value(val) {
                this.data = val ? val.trim() : val;
            }
        },
        methods: {
            text: item => item.jenisSetoran + " - " + item.namaSetoran,
            onSelect() {
                this.$emit("input", this.data);
                this.$emit("select", this.data);
                this.$emit("jenis", this.getValue());
            },
            getValue() {
                let result = "";
                this.listData.map(element => {
                    if (this.data === element.jenisSetoran) {
                        result = element;
                    }
                });
                return result;
            }
        }
    };
</script>